import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { TosGate } from '@/components/TosGate'
import { NameGate } from '@/components/NameGate'
import { Skeleton } from '@/components/ui/skeleton'
import { landingPathForRole } from '@/lib/roleLanding'
import type { Role } from '@/types'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: Role[]
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="p-8 space-y-4">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to={landingPathForRole(user.role)} replace />
  }

  if (user?.must_change_password && location.pathname !== '/getting-started') {
    return <Navigate to="/getting-started" replace />
  }

  return (
    <>
      {children}
      {user && !user.tos_accepted && <TosGate />}
      {user?.name_missing && <NameGate />}
    </>
  )
}
